import { mainSiteUrl } from '@/mocks/categories';

export default function CTASection() {
  return (
    <section className="relative w-full py-16 md:py-24 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=A%20sophisticated%20luxury%20fashion%20showroom%20with%20premium%20leather%20bags%20belts%20and%20accessories%20artistically%20arranged%20on%20marble%20display%20shelves%2C%20soft%20ambient%20warm%20lighting%2C%20neutral%20beige%20and%20ivory%20tones%2C%20editorial%20commercial%20interior%20photography%20style%20with%20elegant%20refined%20shopping%20experience%20atmosphere&width=1600&height=600&seq=cta-bg-retail&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-black/45" />

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-3xl md:text-4xl font-heading font-semibold text-white mb-4">
          Ready to Explore BaseTao Spreadsheet?
        </h2>
        <p className="text-white/80 text-base md:text-lg mb-8 max-w-lg mx-auto">
          Visit our main platform to browse thousands of products, track orders, and start building your own organized shopping workflow.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3.5 rounded-lg bg-primary-500 text-white font-semibold text-base hover:bg-primary-600 transition-colors duration-200 cursor-pointer"
          >
            Visit Official Platform
            <i className="ri-arrow-right-up-line w-5 h-5 flex items-center justify-center"></i>
          </a>
        </div>
      </div>
    </section>
  );
}